// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__CUq7L","name":"TextInput_name__bZRmv","inputTitle":"TextInput_inputTitle__kP5Xf"};